























































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  OutgoingInvoiceEditModel,
  OutgoingInvoicePositionEditModel,
  OutgoingInvoiceSettingsViewModel,
  OutgoingInvoiceTimeEntryGroupEnum,
  OutgoingInvoiceTimeEntryGroupFilter,
  TimeEntryFilter,
  TimeEntryFilterTimeFrame,
} from '@/services/api/nswag/stapiclient_generated';
import { outgoingInvoiceApi } from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import { notifySuccess } from '@/utlitities/notifications';
import OutgoingInvoiceExport from '@/views/OutgoingInvoice/OutgoingInvoiceExport.vue';
//@ts-ignore
import * as FileSaver from 'file-saver';
import { roundToTwo } from '@/utlitities/helper';
import { getOutgoingInvoiceLayoutOptions, IOutgoingInvoicePlaceholders } from '@/views/OutgoingInvoice/outgoing-invoice-helper';
import { DelayLoading } from '@/utlitities/delay-loading';
import { DialogResponse } from 'vue-tailwind/dist/components/TDialog';

@Component({
  components: { OutgoingInvoiceExport },
})
export default class OutgoingInvoiceDocument extends Vue {
  @Prop() value!: OutgoingInvoiceEditModel;
  @Prop() placeholders!: IOutgoingInvoicePlaceholders;

  filter: OutgoingInvoiceTimeEntryGroupFilter = OutgoingInvoiceTimeEntryGroupFilter.fromJS({});
  settings: OutgoingInvoiceSettingsViewModel = OutgoingInvoiceSettingsViewModel.fromJS({});
  preview: boolean = false;
  pdfLoading = false;
  xmlLoading = false;
  pdfActivityLoading = false;
  saveLoading = false;

  delayLoading: DelayLoading = new DelayLoading();
  watchFn: any;

  async mounted() {
    this.settings = await outgoingInvoiceApi.getSettingsViewModel();
    this.filter.timeEntryIds = this.timeEntryIds;
    this.filter.group = this.filterGroup;
    this.filter.displayDatesOnGroup = this.displayDatesOnGroup;

    this.watchFn = this.$watch('editModel.timeEntryIds', async () => {
      this.filter.timeEntryIds = this.timeEntryIds;
      try {
        this.loading = true;
        await this.reloadPositionsByTimeEntries();
      } finally {
        this.loading = false;
      }
    });
  }

  beforeDestroy() {
    this.watchFn();
  }

  get loading() {
    return this.delayLoading.val;
  }

  set loading(data: boolean) {
    this.delayLoading.val = data;
  }

  loadingImmediate() {
    this.delayLoading.setImmediate();
  }

  get useInvoiceEmailSending() {
    return UserStore.userSettings.useInvoiceEmailSending;
  }

  get isSavedInvoice() {
    return this.editModel.id;
  }

  async reloadPositionsByTimeEntries() {
    let temp = this.editModel.positions?.filter((x) => !x.isCalculated) ?? [];
    this.editModel.positions = [];
    this.editModel.positions.push(...(await outgoingInvoiceApi.getPositionsByTimeEntries(this.filter)));
    this.editModel.positions.push(...temp);
  }

  editSettings() {
    this.$router.push({ name: 'EditOutInvAccountSettings' });
  }

  editCustomer() {
    this.$router.push({ name: 'EditCustomerInvoice', params: { customerId: this.editModel.customerId!.toString() } });
  }

  get layoutOptions() {
    let layoutOptions = getOutgoingInvoiceLayoutOptions();
    if (!this.settings.customLayoutComponentName) {
      layoutOptions = layoutOptions.filter((_) => _.id != 'Custom');
    }

    return layoutOptions;
  }

  get contactNamePlaceholder() {
    if (this.editModel.contactNamePlaceholder && (this.editModel.description?.indexOf('{Ansprechpartner}') ?? -1) > -1) {
      return this.editModel.contactNamePlaceholder;
    }
  }

  get dateFromPlaceholder() {
    if (this.editModel.dateFromPlaceholder && (this.editModel.description?.indexOf('{DatumVon}') ?? -1) > -1) {
      return this.editModel.dateFromPlaceholder;
    }
  }

  get dateToPlaceholder() {
    if (this.editModel.dateToPlaceholder && (this.editModel.description?.indexOf('{DatumBis}') ?? -1) > -1) {
      return this.editModel.dateToPlaceholder;
    }
  }

  get editModel() {
    return this.value;
  }

  set editModel(data: OutgoingInvoiceEditModel) {
    this.$emit('input', data);
  }

  get timeEntryIds() {
    return this.editModel.timeEntryIds;
  }

  get filterGroup() {
    return this.editModel.timeEntryGrouping ?? OutgoingInvoiceTimeEntryGroupEnum.Rate;
  }

  get displayDatesOnGroup() {
    return this.editModel.displayDatesOnGroup ?? false;
  }

  get units() {
    return ['h', 'St.'];
  }

  get currency() {
    return UserStore.userSettings.currency;
  }

  get amountNet() {
    return roundToTwo(this.editModel.positions!.map((x) => x.revenue).reduce((x, y) => x! + y!, 0) ?? 0);
  }

  get amountVat() {
    return roundToTwo(this.amountNet * (this.editModel.vatRate ?? 0)) / 100;
  }

  get amountGross() {
    return this.amountNet + this.amountVat;
  }

  get timeEntryGroups(): any[] {
    return [
      {
        value: OutgoingInvoiceTimeEntryGroupEnum.ProjectTask,
        description: this.$t('Leistung'),
      },
      {
        value: OutgoingInvoiceTimeEntryGroupEnum.Rate,
        description: this.$t('Stundensatz'),
      },
      {
        value: OutgoingInvoiceTimeEntryGroupEnum.Project,
        description: this.$t('Projekt'),
      },
      {
        value: OutgoingInvoiceTimeEntryGroupEnum.TimeEntry,
        description: this.$t('Zeiteintrag'),
      },
    ];
  }

  get displayDisplayDatesOnGroup() {
    return this.filter.group == OutgoingInvoiceTimeEntryGroupEnum.TimeEntry;
  }

  async filterGroupChanged(group: OutgoingInvoiceTimeEntryGroupEnum) {
    this.filter.group = group;
    this.editModel.timeEntryGrouping = group;
    try {
      this.loading = true;
      await this.reloadPositionsByTimeEntries();
    } finally {
      this.loading = false;
    }
  }

  async displayDatesOnGroupChanged(displayDatesOnGroup: boolean) {
    this.filter.displayDatesOnGroup = displayDatesOnGroup;
    this.editModel.displayDatesOnGroup = displayDatesOnGroup;
    try {
      this.loading = true;
      await this.reloadPositionsByTimeEntries();
    } finally {
      this.loading = false;
    }
  }

  async addPosition() {
    try {
      let t = setTimeout(() => {
        this.loading = true;
      }, 500);
      let newPos = await outgoingInvoiceApi.getNewPositionEditModel();
      this.editModel.positions!.push(newPos);
      clearTimeout(t);
    } finally {
      this.loading = false;
    }
  }

  removePosition(index: number) {
    this.editModel.positions!.splice(index, 1);
  }

  calcRevenue(pos: OutgoingInvoicePositionEditModel) {
    pos.revenue = roundToTwo(pos.rateAmount ?? 0) * roundToTwo(pos.quantity ?? 0);
  }

  async printInvoice() {
    try {
      this.pdfLoading = true;
      if (this.editModel.id == 0) {
        await this.save();
      }

      let result = await outgoingInvoiceApi.getPdf(this.editModel.id!);
      FileSaver.saveAs(result.data, this.$t('Rechnung').toString() + '_' + this.editModel.invoiceNo + '.pdf');
    } finally {
      this.pdfLoading = false;
    }
  }

  async getEInvoiceXml() {
    try {
      this.xmlLoading = true;
      if (this.editModel.id == 0) {
        await this.save();
      }

      let result = await outgoingInvoiceApi.getXml(this.editModel.id!);
      FileSaver.saveAs(result.data, this.$t('Rechnung').toString() + '_' + this.editModel.invoiceNo + '.xml');
    } finally {
      this.xmlLoading = false;
    }
  }

  async printActivityReport() {
    try {
      this.pdfActivityLoading = true;
      if (this.editModel.id == 0) {
        await this.save();
      }

      let result = await outgoingInvoiceApi.getActivityReport(this.editModel.id!);
      FileSaver.saveAs(result.data, this.$t('Leistungsnachweis').toString() + '_' + this.editModel.invoiceNo + '.pdf');
    } finally {
      this.pdfActivityLoading = false;
    }
  }

  async save() {
    try {
      this.saveLoading = true;

      if (this.editModel.filterJson) {
        let filter = TimeEntryFilter.fromJS(JSON.parse(this.editModel.filterJson!));
        this.editModel.filterTimeFrame = filter.timeframe;

        filter.timeframe = TimeEntryFilterTimeFrame.Custom;
        this.editModel.filterJson = JSON.stringify(filter);
      }

      if (this.editModel.id == 0) {
        this.editModel.id = await outgoingInvoiceApi.post(this.editModel);
      } else {
        await outgoingInvoiceApi.put(this.editModel);
      }
    } finally {
      this.saveLoading = false;
    }

    notifySuccess('Erfolgreich gespeichert');
  }

  async confirmOwnLayout() {
    const res: DialogResponse = await this.$dialog.confirm({
      title: this.$t('Bestätigung').toString(),
      text: this.$t(
        'Wenn Sie ein eigenes Rechnungslayout haben, dann können wir dieses für Sie hinterlegen. Bitte melden Sie sich bei uns per E-Mail (mail@spiketime.de) oder über die Support-Funktion.'
      ),
      variant: 'success',
      okButtonText: this.$t('Ok, verstanden').toString(),
      cancelButtonText: this.$t('Abbrechen').toString(),
    });
  }
}
